module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daymodrain-3a88b0bcfb1cde4d7ab48c1081a84774.svg";